import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-04/lesson-09/task-02";
import config from "appConfig";

const task: Slide = {
  titleHtml:
    "A 2 cm diameter coil with 6 turns is immersed in a magnetic field of 1 T.<br>A DC current of 0.2 A flows through it. Calculate the Lorentz force applied to it.",
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [3, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/09/task/task-2.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
